<template>
    <svg class="cnm-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="4.95703" width="12" height="1.5" fill="white"/>
        <rect x="13" y="4.95703" width="16" height="1.5" transform="rotate(90 13 4.95703)" fill="white"/>
    </svg>
</template>
